// extracted by mini-css-extract-plugin
export default {"TableContainer":"indicatorRecordsTable_TableContainer__vzZP2","TableContent":"indicatorRecordsTable_TableContent__v8G01"};